module.exports = __webpack_public_path__ + "img/top-left-corner.d9286e69.svg";